import { render, staticRenderFns } from "./shopping-tools-tiles.vue?vue&type=template&id=97a54424&scoped=true&"
import script from "./shopping-tools-tiles.vue?vue&type=script&lang=js&"
export * from "./shopping-tools-tiles.vue?vue&type=script&lang=js&"
import style0 from "./shopping-tools-tiles.vue?vue&type=style&index=0&id=97a54424&lang=scss&scoped=true&"
import style1 from "./shopping-tools-tiles.vue?vue&type=style&index=1&lang=css&"
import style2 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=2&id=97a54424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a54424",
  null
  
)

export default component.exports